import classNames from 'classnames';
import { FC, Fragment, ReactElement } from 'react';

import { Separator } from '../Separator/Separator';
import styles from './SmallActionContainer.module.scss';

export type Action = {
  alt: string;
  content: ReactElement;
  header: ReactElement;
  icon?: ReactElement;
  iconURL?: string;
};

interface SmallActionContainerProps {
  actions: Action[];
  mobileOnly?: boolean;
  wide?: boolean;
}

const SmallActionContainer: FC<SmallActionContainerProps> = ({ actions, wide, mobileOnly }) => {
  return (
    <div className={classNames({
      [styles.root]: true,
      [styles.row]: wide,
      [styles.column]: !wide,
      [styles.mobileOnly]: mobileOnly,
    })}>
      {
        actions.map((action, index) => (
          <Fragment key={index}>
            <div className={classNames({
              [styles.container]: true,
              [styles.smallContainer]: wide,
            })}>
              {action.iconURL && (
                <img
                  alt={action.alt}
                  height={24}
                  src={action.iconURL}
                  width={24} />
              )}
              {action.icon}
              <div className={styles.contentContainer}>
                <h3 className={classNames({
                  [styles.header]: true,
                })}>{action.header}</h3>
                <div className={styles.content}>{action.content}</div>

              </div>
            </div>
            {(index < actions.length - 1) && <Separator classes={classNames({
              [styles.separator]: true,
              [styles.separatorWide]: wide,
            })}/>}
          </Fragment>
        ))
      }
    </div>
  );
};

export default SmallActionContainer;
